import { signIn } from "next-auth/react";
import { styled } from "@material-ui/core/styles";
import { LoadingButton } from '@material-ui/lab';
import {
	Box,
	Card,
	Stack,
	Alert,
	Divider,
	Container,
	Typography,
	Button,
	TextField
} from "@material-ui/core";
import Page from "../../src/components/Page";
import { MHidden } from "../../src/components/@material-extend";
import { useRouter } from "next/router";

import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { Icon } from "@iconify/react";
import githubfill from "@iconify/icons-eva/github-fill";
import emailoutline from "@iconify/icons-eva/email-outline";
import MainLogo from "../../src/components/MainLogo";

import { getCookies, getCookie, setCookie, deleteCookie } from 'cookies-next';
SignIn.auth = {
	isLogin: true,
};

export default function SignIn() {
	const router = useRouter();
	const { enqueueSnackbar } = useSnackbar();

	const errorType = router.query.error;

	const errorsAndMessages = {
		Signin: "Tente fazer login com outra conta",
		OAuthSignin: "Tente fazer login com outra conta",
		OAuthCallback: "Tente fazer login com outra conta",
		OAuthCreateAccount: "Tente fazer login com outra conta",
		EmailCreateAccount: "Tente fazer login com outra conta",
		Callback: "Tente fazer login com outra conta",
		OAuthAccountNotLinked: "Para entrar, faça login com a mesma conta que você usou originalmente",
		EmailSignin: "Confirme o seu email para terminar o login",
		CredentialsSignin: "Erro no login devido a suas credenciais",
		SessionTimeout: "Faça login novamente para acessar a página",
		OAuthWithoutEmail: "Você precisa de disponibilizar um email ou usar um dos métodos abaixo para fazer cadastro na TechNation",
		AccountDisabled: "Sua conta foi suspensa!",
		default: "Erro no Login"
	};

	var _errors$errorType;
	const error = errorType && ((_errors$errorType = errorsAndMessages[errorType]) !== null && _errors$errorType !== void 0 ? _errors$errorType : errorsAndMessages.default);

	const errorComponent = error ? (
		<Alert severity="error" sx={{ mb: 3 }}>
			{error}
		</Alert>
	) : null

	if (router.query?.token) {
		setCookie('token', router.query.token, { maxAge: 60 * 60 * 24 })
	}
	if (router.query?.token_invite_company) {
		setCookie('token_invite_company', router.query.token_invite_company, { maxAge: 60 * 60 * 24 })
	}

	if (router.query?.token_invite_ps) {
		setCookie('token_invite_selection_process', router.query.token_invite_ps, { maxAge: 60 * 6 * 24 * 2 })
	}

	const NewEmailLoginSchema = Yup.object().shape({
		email: Yup.string().email('O campo deve ser um email válido'),
	});

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			email: '',
		},
		validationSchema: NewEmailLoginSchema,
		onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
			try {
				signIn('email', { email: values.email, callbackUrl: window.location.href })
				enqueueSnackbar('Enviando email', { variant: 'info' });
				setSubmitting(false);
			} catch (error) {
				enqueueSnackbar('Erro ao enviar o email', { variant: 'error' });
				console.error(error);
				setSubmitting(false);
				setErrors(error);
			}
		}
	});

	const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

	return (
		<RootStyle title="Technation - Login">
			<MHidden width="mdDown">
				<SectionStyle>
					<Typography variant="h5" sx={{ px: 5, mt: 10, mb: 5 }}>
						Conectando programadores com os conhecimentos e experiências que eles precisam!
					</Typography>
					<img src="/static/illustrations/illustration_login.png" alt="login" />
				</SectionStyle>
			</MHidden>

			<Container maxWidth="sm">
				<ContentStyle>
					<Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
						<Box sx={{ flexGrow: 1 }}>
							<Box sx={{ width: 1, display: 'flex', justifyContent: 'center', mb: 8 }}>
								<MainLogo />
							</Box>
							<Typography variant="h4" gutterBottom>
								Bem-vindo a TechNation
							</Typography>
							<Typography sx={{ color: 'text.secondary' }}>Entre ou crie sua conta!</Typography>
						</Box>
					</Stack>

					{errorComponent}

					<Button fullWidth size="large" color="tertiaryLight" variant="outlined" sx={{ mb: 1 }} onClick={() => signIn("github")}>
						<Box sx={{ position: "absolute", left: 16, height: 20 }} >
							<Icon icon={githubfill} color="inherit" height={20} />
						</Box>
						<Typography sx={{ ml: 1, color: "#444" }}> Entrar com GitHub </Typography>
					</Button>

					<Button fullWidth size="large" color="tertiaryLight" variant="outlined" sx={{ mb: 1 }} onClick={() => signIn("google")}>
						<Box component="img" alt={"Google Icon"} src={"/static/icons/ic_google.svg"} sx={{ position: "absolute", height: 20, left: 16 }} />
						<Typography sx={{ ml: 1, color: "#444" }}> Entrar com Google </Typography>
					</Button>

					<Button fullWidth size="large" color="tertiaryLight" variant="outlined" onClick={() => signIn("azure-ad")}>
						<Box component="img" alt={"Microsoft Icon"} src={"/static/icons/microsoft_logo.svg"} sx={{ position: "absolute", height: 20, left: 16 }} />
						<Typography sx={{ ml: 1, color: "#444" }}> Entrar com Microsoft </Typography>
					</Button>

					<Divider sx={{ my: 3 }}>
						<Typography variant="body2" sx={{ color: 'text.secondary' }}>
							OU
						</Typography>
					</Divider>

					<FormikProvider value={formik}>
						<Form onSubmit={handleSubmit}>
							<TextField
								fullWidth
								size="small"
								label="Email"
								sx={{ mb: 2 }}
								{...getFieldProps('email')}
								error={Boolean(touched.email && errors.email)}
								helperText={touched.email && errors.email}
							/>
							<LoadingButton fullWidth size="large" color="primary" variant="contained" type="submit" loading={isSubmitting} >
								<Box sx={{ position: "absolute", left: 16, height: 20 }} >
									<Icon icon={emailoutline} color="inherit" height={20} />
								</Box>
								<Typography sx={{ ml: 1 }}> Entrar com Email </Typography>
							</LoadingButton>

						</Form>
					</FormikProvider>

				</ContentStyle>
			</Container>
		</RootStyle>
	);
}

const RootStyle = styled(Page)(({ theme }) => ({
	[theme.breakpoints.up("md")]: {
		display: "flex",
	},
}));

const SectionStyle = styled(Card)(({ theme }) => ({
	width: "100%",
	maxWidth: 464,
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
	maxWidth: 480,
	margin: "auto",
	display: "flex",
	minHeight: "100vh",
	flexDirection: "column",
	justifyContent: "center",
	padding: theme.spacing(12, 0),
}));
